module.exports = __webpack_public_path__ + "static/media/instagram.81f3f342.svg";